import React from "react";
import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme/theme";
import summaryProgress from "../../images/summary_progress.svg";
import star from "../../images/star.svg";
import { waveformOffsetClass } from "./transcript.styles";
import { THEME_COLOR } from "../../styles/colors";

/**
 * Component shown when transcription is actively running
 * Shows transcription in progress with optional requester information
 */
const TranscribingIndicator = ({ 
  rtmsRequesterName, 
  isRtmsStartedByOther
}) => {
  return (
    <Column alignmentHorizontal="start" width="100%" spacing="400" spacingInset="none">
      <img
        src={summaryProgress}
        alt=""
        className={waveformOffsetClass}
      />
      <Text type="h50" alignment="start">
        Transcribing...
      </Text>

      {rtmsRequesterName && isRtmsStartedByOther && (
        <Column spacing="none" spacingInset="600 none none none">
          <Theme tokens={{ boxBorderColorOutline: THEME_COLOR.LIGHT_TEAL }}>
            <Box type="outline" spacingInset="400" width="252px">
              <Row spacing="300">
                <img src={star} alt="star" />
                <Column spacing="none">
                  <Text type="h50" alignment="start">
                    {rtmsRequesterName}
                  </Text>
                  <Text type="b200" alignment="start">
                    started transcription
                  </Text>
                </Column>
              </Row>
            </Box>
          </Theme>
        </Column>
      )}
    </Column>
  );
};

export default TranscribingIndicator;
